export default "__VITE_ASSET__B6mjgnZ3__"